const FigmaLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <path
        d="M45.5 129C57.4 129 67 119.4 67 107.5V86H45.5C33.6 86 24 95.6 24 107.5C24 119.4 33.6 129 45.5 129Z"
        fill="#0ACF83"
      />
      <path
        d="M24 64.5C24 52.6 33.6 43 45.5 43H67V86H45.5C33.6 86 24 76.4 24 64.5Z"
        fill="#00E96C"
      />
      <path
        d="M24 21.5C24 9.6 33.6 0 45.5 0H67V43H45.5C33.6 43 24 33.4 24 21.5Z"
        fill="#00E96C"
      />
      <path
        d="M67 0H88.5C100.4 0 110 9.6 110 21.5C110 33.4 100.4 43 88.5 43H67V0Z"
        fill="#00E96C"
      />
      <path
        d="M110 64.5C110 76.4 100.4 86 88.5 86C76.6 86 67 76.4 67 64.5C67 52.6 76.6 43 88.5 43C100.4 43 110 52.6 110 64.5Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default FigmaLogo;
